import { ProductPreviewType } from 'types/global'

const convertStringPrice = (price: string) => {
  return parseFloat(price.match(/\d|\./g)?.join('') as string)
}

export const sortProductPrice = (
  products: ProductPreviewType[],
  desc: boolean
) => {
  if (desc) {
    return products.sort(
      (p1, p2) =>
        convertStringPrice(p2.price?.calculated_price ?? '0') -
        convertStringPrice(p1.price?.calculated_price ?? '0')
    )
  } else {
    return products.sort(
      (p1, p2) =>
        convertStringPrice(p1.price?.calculated_price ?? '0') -
        convertStringPrice(p2.price?.calculated_price ?? '0')
    )
  }
}
